export const CYCLE_CONSTANTS = {
    STORAGE_KEY: 'selectedCycle',
    // This list will be replaced by API response later
    DEFAULT_CYCLES: [
        { value: 'CYCLE_1', label: 'Cycle 1' },
        { value: 'CYCLE_2', label: 'Cycle 2' },
        { value: 'RTS_1', label: 'RTS 1' },
        { value: 'RTS_2', label: 'RTS 2' },
        { value: 'SAME_DAY_AM', label: 'Same Day AM' },
        { value: 'SAME_DAY_SUNRISE', label: 'Same Day Sunrise' },
        { value: 'AD_HOC_1', label: 'Ad Hoc 1' },
        { value: 'AD_HOC_2', label: 'Ad Hoc 2' },
        { value: 'AD_HOC_3', label: 'Ad Hoc 3' },
        { value: 'SAME_DAY', label: 'Same Day' }
    ]
};
